import { useState } from "react";
import AdminShopOrders from "./AdminShopOrders";
import AdminMerch from "./AdminMerch";

export default function AdminOrders({ ctx }) {
  const [sub, setSub] = useState("shop");
  const shopNew = (ctx.shopOrders || []).filter((o) => o.status === "to_fulfill").length;
  const merchNew = (ctx.merch || []).filter((o) => o.status !== "fulfilled").length;
  const Tab = ({ k, label, badge }) => (
    <button
      data-testid={`orders-tab-${k}`}
      onClick={() => setSub(k)}
      className={`inline-flex items-center gap-2 px-5 py-3 border-2 border-[#121212] text-xs tracking-[0.15em] uppercase font-bold transition-colors ${sub === k ? "bg-[#C6FF33]" : "bg-white hover:bg-[#F2E9D8]"}`}
    >
      {label}
      {badge > 0 && <span className="inline-flex items-center justify-center min-w-5 h-5 px-1.5 bg-[#E0218A] text-white text-[11px] font-bold rounded-full">{badge}</span>}
    </button>
  );
  return (
    <div className="mt-4" data-testid="admin-orders">
      <div className="flex gap-2 flex-wrap">
        <Tab k="shop" label="Shop Orders" badge={shopNew} />
        <Tab k="merch" label="T-Shirt / Merch Orders" badge={merchNew} />
      </div>
      {sub === "shop" ? <AdminShopOrders ctx={ctx} /> : <AdminMerch ctx={ctx} />}
    </div>
  );
}
